import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';

const Imprint = () => {
  const companyDetails = {
    name: 'OLBMI ltd.',
    address: '10 Mnasiadou, 2nd Floor, 1065 Nicosia',
    email: 'support@learnaihub.net',
    website: 'https://learnaihub.net/',
  };

  return (
    <>
      <Header />

      <div className="bg-[#f8f9fa] min-h-screen font-sans pt-24 pb-16">
        <main className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-[2rem] shadow-sm border border-zinc-100 p-8 md:p-14 mb-16">
            <div className="mb-10">
              <h1 className="text-4xl md:text-5xl font-black text-[#042b1f] tracking-tight mb-4">
                Imprint
              </h1>

              <div className="h-1.5 w-12 bg-amber-400 rounded-full mb-8"></div>

              <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                Legal information and website ownership details for LearnAI Hub.
              </p>
            </div>

            <div className="space-y-8">
              <section className="space-y-3">
                <h2 className="text-xl font-bold text-[#042b1f]">Company Information</h2>
                <dl className="grid gap-4 text-sm md:text-base">
                  <div>
                    <dt className="font-bold text-zinc-900">Company Name</dt>
                    <dd className="text-zinc-600 font-medium">{companyDetails.name}</dd>
                  </div>
                  <div>
                    <dt className="font-bold text-zinc-900">Registered Address</dt>
                    <dd className="text-zinc-600 font-medium">{companyDetails.address}</dd>
                  </div>
                  <div>
                    <dt className="font-bold text-zinc-900">Website</dt>
                    <dd className="text-zinc-600 font-medium">
                      <a href={companyDetails.website} className="text-amber-600 font-bold hover:underline">
                        {companyDetails.website}
                      </a>
                    </dd>
                  </div>
                </dl>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-bold text-[#042b1f]">Contact</h2>
                <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                  For legal notices, support, or questions about LearnAI Hub, contact us at{' '}
                  <a href={`mailto:${companyDetails.email}`} className="text-amber-600 font-bold hover:underline">
                    {companyDetails.email}
                  </a>
                  .
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-bold text-[#042b1f]">Responsible for Content</h2>
                <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                  {companyDetails.name}, {companyDetails.address}.
                </p>
              </section>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Imprint;
